module.exports = __webpack_public_path__ + "editor/icon-edit-b670ef72c1ea88f5fefa5957ba424342.svg";